import { MockedRequest, RestHandler, rest } from "msw";

import { ResponsibilityResponse } from "api/getAccidentResponsibility";
import { AccidentResponsibility } from "types/DigitalJourneySession";
import { ErrorResponse } from "types/ErrorResponse";

export const getAccidentResponsibilityHandler = (
  status: number,
  response: ResponsibilityResponse | ErrorResponse
): RestHandler<MockedRequest<ResponsibilityResponse | ErrorResponse>> => {
  return rest.get(`/session/digitalJourney/responsibility`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const accidentResponsibilityHandler = [
  getAccidentResponsibilityHandler(200, { responsibility: AccidentResponsibility.C }),
];
